import React from "react";
import { CustomTable } from "../../../Shared";

export function ListLiveClass(props) {
  const {
    rooms = [],
    loading = false,
    error = null,
    pagination = {},
    currentPage = 1,
    setCurrentPage,
    onItemsPerPageChange,
    onRowClick,
    tableConfig,
  } = props;
  
  if (error) {
    return (
      <p style={{ color: "red", textAlign: "center", margin: "1rem 0" }}>
        {error}
      </p>
    );
  }

  return (
    <div className="student-live-classes__list">
      <CustomTable
        tableConfig={tableConfig}
        data={rooms}
        loading={loading}
        pagination={pagination}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        onItemsPerPageChange={onItemsPerPageChange}
        bordered
        hover
        striped
        onRowClick={onRowClick}
      />
    </div>
  );
}
